module.exports = __webpack_public_path__ + "B_left.bb0f55f1.png";